import React, {useCallback, useMemo} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {useTranslation} from 'react-i18next';
import PlanEditorInnerContainer from '../../../../../components/Editor/PlanEditorInnerContainer';
import Separator from '../../../../../components/Simple/Sepperator';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import EmptyRow from '../../../../../components/Simple/EmptyRow';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import {SMCSelect, SMCOption} from '../../../../../components/Simple/SMCSelect';
import SMCIcon from '../../../../../components/Simple/SMCIcon';
import RowLayout from '../../../../../components/Layouts/RowLayout';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.threatPrevention;
const pageId = pageSchema.pageId;

function BaseThreatPrevention({
    pageData,
    setObjectData,
    pageDisabled,
    setEditorPageId
}) {
    const { t } = useTranslation();

    const manageInSmp       = pageData[pageSchema.manageInSmp];
    const highConfidence    = pageData[pageSchema.highConfidence];
    const mediumConfidence  = pageData[pageSchema.mediumConfidence];
    const lowConfidence     = pageData[pageSchema.lowConfidence];
    const performanceImpact = pageData[pageSchema.performanceImpact];
    const track             = pageData[pageSchema.track];

    const confidenceValues        = pageSchema.confidenceValues;
    const performanceImpactValues = pageSchema.performanceImpactValues;
    const trackValues             = pageSchema.trackValues;

    const setPageValue = useCallback((param, newValue) => {
        setObjectData([pageId, param], newValue);
    }, [setObjectData]);

    const confidenceOptions = useMemo(() => (
        <>
        <SMCOption value={confidenceValues.ask}>{t('SMP.PLAN.TP.ASK')}</SMCOption>
        <SMCOption value={confidenceValues.prevent}>{t('SMP.PLAN.TP.PREVENT')}</SMCOption>
        <SMCOption value={confidenceValues.detect}>{t('SMP.PLAN.TP.DETECT')}</SMCOption>
        <SMCOption value={confidenceValues.inactive}>{t('SMP.PLAN.TP.INACTIVE')}</SMCOption>
        </>
    ), [confidenceValues, t]);


    return (
        <EditorLayout>
            <SMCToggleSwitch
                disabled={pageDisabled}
                checked={manageInSmp}
                onChange={checked => setPageValue(pageSchema.manageInSmp, checked)}
                label={t('SMP.PLAN.MANAGE_IN_SMP')}
            />
            <Separator isMainSeparator/>
            <PlanEditorInnerContainer title={t('SMP.PLAN.TP.TP_POLICY')} managedInSmp={manageInSmp}>
                <RowLayout spacing="8px">
                    <SMCIcon icon="info" />
                    <span>
                        <SMCLabel>{t('SMP.PLAN.TP.INFO1')}</SMCLabel>
                        <SMCLabel>{t('SMP.PLAN.TP.INFO2')} <span className="Link" onClick={() => setEditorPageId(GatewayGetSchema.pages.unifiedThreatPrevention.pageId)}> {t('SMP.PLAN.UNIFIED_THREAT_PREV_POLICY')}</span></SMCLabel>
                    </span>
                </RowLayout>

                <EmptyRow />

                {/* High confidence */}
                <SMCSelect
                    disabled={pageDisabled || !manageInSmp}
                    value={highConfidence}
                    onChange={e => setPageValue(pageSchema.highConfidence, e.target.value)}
                    label={t('SMP.PLAN.TP.HIGH_CONF')+':'}
                >
                    {confidenceOptions}
                </SMCSelect>
                {/* Medium confidence */}
                <SMCSelect
                    disabled={pageDisabled || !manageInSmp}
                    value={mediumConfidence}
                    onChange={e => setPageValue(pageSchema.mediumConfidence, e.target.value)}
                    label={t('SMP.PLAN.TP.MED_CONF')+':'}
                >
                    {confidenceOptions}
                </SMCSelect>
                {/* Low confidence */}
                <SMCSelect
                    disabled={pageDisabled || !manageInSmp}
                    value={lowConfidence}
                    onChange={e => setPageValue(pageSchema.lowConfidence, e.target.value)}
                    label={t('SMP.PLAN.TP.LOW_CONF')+':'}
                >
                    {confidenceOptions}
                </SMCSelect>

                {/* Performance impact */}
                <SMCSelect
                    disabled={pageDisabled || !manageInSmp}
                    value={performanceImpact}
                    onChange={e => setPageValue(pageSchema.performanceImpact, e.target.value)}
                    label={t('SMP.PLAN.TP.PERFORMANCE_IMPACT')+':'}
                >
                    <SMCOption value={performanceImpactValues.low}>{t('SMP.PLAN.TP.LOW')}</SMCOption>
                    <SMCOption value={performanceImpactValues.medium}>{t('SMP.PLAN.TP.MED_OR_LOWER')}</SMCOption>
                    <SMCOption value={performanceImpactValues.high}>{t('SMP.PLAN.TP.HIGH_OR_LOWER')}</SMCOption>
                </SMCSelect>

                <EmptyRow />

                {/* Tracking options */}
                <SMCSelect
                    disabled={pageDisabled || !manageInSmp}
                    value={track}
                    onChange={e => setPageValue(pageSchema.track, e.target.value)}
                    label={t('SMP.PLAN.TP.TRACKING_OPTIONS')+':'}
                >
                    <SMCOption value={trackValues.log}>{t('SMP.PLAN.TP.LOG')}</SMCOption>
                    <SMCOption value={trackValues.alert}>{t('SMP.PLAN.TP.ALERT')}</SMCOption>
                    <SMCOption value={trackValues.none}>{t('SMP.PLAN.TP.NONE')}</SMCOption>
                </SMCSelect>
                

            </PlanEditorInnerContainer>
        </EditorLayout>
    );
}

export default BaseThreatPrevention;